// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { numberList16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-number-list': IconNumberList;
    }
}

/**
 * The icon component for the 'numberList' icon
 */
export class IconNumberList extends Icon {
    public constructor() {
        super(numberList16X16);
    }
}

registerIcon('icon-number-list', IconNumberList);
export const iconNumberListTag = 'nimble-icon-number-list';
